export default {"src":"/_next/static/media/close.c977e557.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};